<template>
  <transition
    enter-active-class="transition-colors ease-in duration-500"
    leave-active-class="hidden"
    :enter-from-class="transitionClass"
  >
    <slot />
  </transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{ price: number | string }>();

const transitionClass = ref();

watch(
  () => props.price,
  (price, prevPrice) => {
    transitionClass.value =
      Number(price) > Number(prevPrice)
        ? 'text-brand-primary'
        : 'text-critical-primary';
  }
);
</script>
